//
//
//
//
//
//

export default {
  props: {
    background: {
      type: Object,
      default: () => {},
    }
  }
};
